import Vue from "vue"

const appData = require('./assets/jsons/appData.json')

Vue.filter('filterTruncate', function (value, limit) {
    if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...';
    }
    return value
})

Vue.filter("filterDateTimeFormat", 
    value =>  {       
        if (!value) return '';
        var ts = new Date(Math.abs(value)); //Hibás kviz válasznál negatív értékkel jelezzük ezért kell az abs        
        var df=ts.toLocaleDateString().replace(/\s/g, '') + ' ' + ts.toLocaleTimeString();
        return df;
    }
);

Vue.filter("filterTimeFormat", 
    value =>  {       
        if (!value) return '';
        var ts = new Date(Math.abs(value)); //Hibás kviz válasznál negatív értékkel jelezzük ezért kell az abs
        var df=ts.toLocaleTimeString();
        return df;
    }
);

Vue.filter("filterDateFormat", 
    value =>  {       
        if (!value) return '';
        var ts = new Date(Math.abs(value)); //Hibás kviz válasznál negatív értékkel jelezzük ezért kell az abs        
        var df=ts.toLocaleDateString().replace(/\s/g, '');
        return df;
    }
);

Vue.filter("filterDateFormat2", 
    value =>  {       
        if (!value) return '-';
        var ts = new Date(Math.abs(value)); //Hibás kviz válasznál negatív értékkel jelezzük ezért kell az abs        
        var df=ts.toLocaleDateString().replace(/\s/g, '');
        return df;
    }
);

Vue.filter("filterNumberToTime", 
    value =>  {     
        if (!value) return '';     
        var sec_num = parseInt(value,10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    }
);

Vue.filter("filterNumberToTime2", function (value) {
    if (value) {
        var sec_num = parseInt(value, 10); 
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes;
    } else return '';
});

var certStatus=appData.certStatus;
Vue.filter("filterNumberToStatus", 
    value =>  { 
        if (!value) return '';  
        for (var i in certStatus){
            if (certStatus[i].sign==value) return certStatus[i].name;
        }        
        return '';
    }
);

var payStatus=appData.payStatus;
Vue.filter("filterPaymentStatus", 
    value =>  { 
        if (!value) return '';  
        for (var i in payStatus){
            if (payStatus[i].sign==value) return payStatus[i].name;
        }        
        return '';
    }
);

Vue.filter("filterNumberToYesOrNo", 
    value =>  { 
        if (value==0) return "Nem";      
        if (value==1) return "Igen";
        return "";
    }
);

var status=appData.status;
Vue.filter("filterStatusToString", 
    value =>  { 
        if (!value) return '';  
        for (var i in status){
            if (status[i].sign==value) return status[i].name;
        }        
        return '';
    }
);

Vue.filter("filterFloatRound", 
    value =>  {       
        return Number((parseFloat(value)).toFixed(2));
    }
);

Vue.filter("filterRound", 
    value =>  {       
        return Number((parseFloat(value)).toFixed(0));
    }
);

var landscape = appData.landscape
Vue.filter("filterLandscapeToString", 
    value =>  {       
        if (!value) return '';        
        for (var i in landscape){
            if (landscape[i].id==value) return landscape[i].name;
        }        
        return '';
    }
);

var prise = appData.prise;
Vue.filter("filterPriseToString", 
    value =>  {       
        if (!value) return '';        
        for (var i in prise){
            if (prise[i].sign==value) return prise[i].name;
        }        
        return '';
    }
);

Vue.filter("filterNumberToDist", function(value){
    var out='';
    if (value) out=Number((parseFloat(value)).toFixed(2)) + ' km';            
    return out;
});                                                              

Vue.filter("filterAvgSpeed", function(value) {
    var out='';
    if (value) out=Number((parseFloat(value)).toFixed(2)) + ' km/h';            
    return out;
});  